(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/rules-and-terms/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/syndicate/rules-and-terms/assets/javascripts/prescript.js');

var svs = svs || {};
svs.syndicate = svs.syndicate || {};
svs.syndicate.rules_and_terms = svs.syndicate.rules_and_terms || {};
svs.syndicate.rules_and_terms.data = svs.syndicate.rules_and_terms.data || {};
svs.syndicate.rules_and_terms.data.serviceTerms = svs.syndicate.rules_and_terms.data.serviceTerms || {};


 })(window);